var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createFieldSelector } from '@mdpp/od-belt';
import { clone } from 'lodash';
import moment from 'moment-timezone';
import React from 'react';
import { ODActionWrapper } from './actions/ODActionWrapper';
import { ODRendererFactory } from './renderer/ODRendererFactory';
var ODListColumnBuilder = /** @class */ (function () {
    function ODListColumnBuilder(schema) {
        this.buildFunctions = [];
        var key = schema.key, title = schema.title, selector = schema.selector, renderer = schema.renderer, clickAction = schema.clickAction;
        this.defaultKey = key.toString();
        this.initialData = {
            id: key.toString(),
            title: title,
            transform: function (v) { return ''; },
            thClass: 'text-left',
            className: 'text-left user-td',
        };
        var s = createFieldSelector(selector);
        var select = function (v) { return s.select(v); };
        this.buildFunctions.push(function (data, context) {
            // for now, use ODListColumnContext as renderer's context.
            data.transform = function (v) { return (React.createElement(ODActionWrapper, { action: clickAction, value: v, context: context },
                React.createElement(ODRendererFactory, { def: renderer, value: select(v), context: context, originalValue: v }))); };
            return data;
        });
    }
    ODListColumnBuilder.prototype.time = function (key) {
        if (key === void 0) { key = this.defaultKey; }
        this.buildFunctions.push(function (data, context) {
            data.transform = function (v) { return (v[key] ? moment(v[key]).format('YYYY-MM-DD HH:mm') : '-'); };
            return data;
        });
        return this;
    };
    ODListColumnBuilder.prototype.image = function (imgProps, key) {
        if (key === void 0) { key = this.defaultKey; }
        this.buildFunctions.push(function (data, context) {
            data.transform = function (v) {
                var link = v[key];
                if (!link) {
                    return (React.createElement("img", __assign({ alt: "empty", src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" }, imgProps)));
                }
                return React.createElement("img", __assign({ alt: key.toString(), src: link }, imgProps));
            };
            return data;
        });
        return this;
    };
    ODListColumnBuilder.prototype.build = function (context) {
        return this.buildFunctions.reduce(function (acc, fn) { return fn(acc, context); }, clone(this.initialData));
    };
    return ODListColumnBuilder;
}());
export { ODListColumnBuilder };
//# sourceMappingURL=ODListColumnBuilder.js.map